/* eslint-disable react-hooks/exhaustive-deps */
//react imports
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

//redux imports
import { getAllCategories } from "../../../../../redux/features/sharedResources/sharedResources";

//component imports
import CategoriesEdit from "../../../../../components/_utils/AccountCreationComponents/CategoriesEdit";
import SmallPopup from "../../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../../components/_utils/CommonSteppers/PrimaryStepper";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent";
import {
  editReimbursementAccount,
  resetEditReimbursementAccount,
  viewAccountDetailR,
} from "../../../../../redux/features/accounts/ReimburseAccount";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import SmallPopupWithBulletPoints from "../../../../../components/_utils/CommonSmallPopupWithBulletPoint";

const ReimbursementCategories = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const { id } = params;

  const sliceCategory = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  const { categoriesLoading } = useSelector((state) => state.sharedResources);

  const {
    reimbursementAccountEditData,
    viewAccountDetailData,
    viewAccountDetailLoading,
    reimbursementAccountEditLoading,
  } = useSelector((state) => state.ReimburseAccount);

  const isCategoryLoading = viewAccountDetailLoading || categoriesLoading;

  // usestates
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [sliceCategories, setSliceCategories] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [isUpdateDisabled, setIsUpdateDisabled] = useState(true);
  const [openPopEdit, setOpenPopEdit] = useState(false);
  const [showAlertCategories, setShowAlertCategories] = useState(false);
  const [buttondisable, setButtondisable] = useState(false);
  const [updateActive, setUpdateActive] = useState(false);
  const [initialCategories, setInitialCategories] = useState([]);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      nextHoverOption: "black",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextIsEnabled: !isUpdateDisabled && !buttondisable && !updateActive,
      stepperText: "Categories",
      nextIsLoading: reimbursementAccountEditLoading,
      nextLoaderNeeded: true,
    },
  ];

  const handleUpdateAccount = async () => {
    if (updateActive) return;
    const willShowUnsafePopup =
      (selectedCategories?.length ===
        sliceCategory.filter((category) => category?.active === "Y")?.length &&
        !showAlertCategories) ||
      (!selectedCategories?.length && !showAlertCategories);

    if (willShowUnsafePopup) {
      setShowAlertCategories(true);
    } else {
      setUpdateActive(true);

      const response = await dispatch(
        editReimbursementAccount({
          id: id,
          category_ids: selectedCategories,
          navigate,
        }),
      );

      if (response?.error?.message === "Rejected") {
        setButtondisable(false);
        setUpdateActive(false);
      } else {
        setButtondisable(true);
      }
      setShowAlertCategories(false);
    }
  };

  const handleBack = () => {
    if (!isUpdateDisabled) {
      setOpenPopEdit(true);
    } else {
      navigate(GlobalConfiguration?.navigate_back);
    }
  };

  const toggleSelectAll = () => {
    if (selectedCategories.length === sliceCategories.length) {
      setSelectedCategories([]);
    } else {
      setSelectedCategories(sliceCategories.map((cat) => cat.id));
    }
  };

  const handleCategorySelect = (categoryId) => {
    const category = sliceCategories.find((c) => c.id === categoryId);
    if (!category) return;

    const updated = selectedCategories.includes(category.id)
      ? selectedCategories.filter((id) => id !== category.id)
      : [...selectedCategories, category.id];

    setSelectedCategories(updated);
  };

  const handleConfirm = () => {
    navigate(GlobalConfiguration?.navigate_back);
  };

  useEffect(() => {
    if (reimbursementAccountEditData?.status === true) {
      navigate(
        `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/categories_edit_success/${id}`,
        {
          state: { updatedFields: ["category"] },
          replace: true,
        },
      );
      dispatch(resetEditReimbursementAccount());
    }
  }, [reimbursementAccountEditData]);

  useEffect(() => {
    const fetchCategoryData = async () => {
      try {
        let response1 = await dispatch(viewAccountDetailR({ id }));
        if (
          response1?.error?.message === "Request failed with status code 404"
        ) {
          navigate("*");
          return;
        }

        let response2 = await dispatch(getAllCategories(id));
        if (
          response2?.error?.message === "Request failed with status code 404"
        ) {
          navigate("*");
          return;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCategoryData();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    setSliceCategories(
      sliceCategory.filter((category) => category?.active === "Y"),
    );
  }, [sliceCategory]);

  useEffect(() => {
    if (!viewAccountDetailLoading && viewAccountDetailData?.status === true) {
      const beneficiaryData = viewAccountDetailData?.reimbursement_accounts[0];
      const selectedCategoriesArray = beneficiaryData.category_ids.map(
        (x) => x.category_id,
      );
      setSelectedCategories(selectedCategoriesArray);
      setInitialCategories(selectedCategoriesArray);
    }
  }, [dispatch, viewAccountDetailData, viewAccountDetailLoading]);

  useEffect(() => {
    const allInitiallyAssigned =
      initialCategories.length === sliceCategories.length;

    const sameAsInitial =
      selectedCategories.length === initialCategories.length &&
      selectedCategories.every((cat) => initialCategories.includes(cat));

    if (
      initialCategories.length === GlobalConfiguration.lengthCheckZero &&
      selectedCategories.length === GlobalConfiguration.lengthCheckZero
    ) {
      setIsUpdateDisabled(true);
    } else if (sameAsInitial) {
      setIsUpdateDisabled(true);
    } else if (
      allInitiallyAssigned &&
      selectedCategories.length === GlobalConfiguration.lengthCheckZero
    ) {
      setIsUpdateDisabled(false);
    } else {
      setIsUpdateDisabled(false);
    }

    setSelectAllChecked(
      sliceCategories.length > GlobalConfiguration.lengthCheckZero &&
        selectedCategories.length === sliceCategories.length,
    );
  }, [selectedCategories, sliceCategories, initialCategories]);

  const sortedCategories = sliceCategories;

  useEffect(() => {
    const handleEnterKeyPress = (e) => {
      if (
        e.key === "Enter" &&
        !isUpdateDisabled &&
        !buttondisable &&
        !updateActive
      ) {
        handleUpdateAccount();
      }
    };

    document.addEventListener("keydown", handleEnterKeyPress);

    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, [
    isUpdateDisabled,
    buttondisable,
    updateActive,
    selectedCategories,
    showAlertCategories,
    sliceCategory,
  ]);

  return (
    <div className="edit-1024-con bg-primary-bg">
      <div
        className="edit-category-main"
        style={{
          overflowY: showAlertCategories ? "hidden" : "scroll",
          scrollbarWidth: "none",
        }}
      >
        {showAlertCategories && (
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <SmallPopupWithBulletPoints
              headerTitle={"Unsafe to proceed"}
              bulletPoints={[
                "All categories will be linked to a single account.",
                "It is recommended to distribute categories across appropriate accounts.",
              ]}
              headerFontWeight="semibold"
              headerFontColor="negative-act"
              textSize="font-md"
              btnOneText="Cancel"
              btnOneBtnType="button"
              btnOneEnabledBgColor="transparent"
              btnOneHandleFunction={() => {
                setShowAlertCategories(false);
                setUpdateActive(false);
              }}
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneHoverOption="white"
              btnTwoText="Proceed"
              btnTwoBtnType="button"
              btnTwoHandleFunction={handleUpdateAccount}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoHoverOption="black"
            />
          </div>
        )}
        {openPopEdit && (
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <SmallPopup
              headerTitle={"Confirm leaving this page?"}
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              subtext="Leaving this page will exit from the current flow."
              btnOneText="Stay"
              btnOneBtnType="button"
              btnOneEnabledBgColor="transparent"
              btnOneHandleFunction={() => setOpenPopEdit(false)}
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneHoverOption="white"
              btnTwoText="Leave"
              btnTwoBtnType="button"
              btnTwoHandleFunction={handleConfirm}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoHoverOption="black"
            />
          </div>
        )}
        <div className="h-navbar-breadcrumb-height hidden Qmd:block"></div>
        <div className="main_edit_category_stepper_div Qmd:relative">
          <PrimaryStepper
            activeStep={0}
            handleForwardAction={handleUpdateAccount}
            handleBackwardAction={handleBack}
            dataArray={dataArray}
          />
        </div>
        <div className="w-width-full relative Qmd:hidden block">
          <TopNavComponent
            isFormattingNotRequired
            topNavSubText="Edit category"
            topNavHeader={"Reimbursement Account"}
            topNavCtaBtn1Props={{
              btnText: "Update",
              btnType: "button",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              inActiveVariantNeeded: true,
              disabledBgColor: "var(--text-disabled)",
              isDisabled: !(
                !isUpdateDisabled &&
                !buttondisable &&
                !updateActive
              ),
              handleFunction:
                !isUpdateDisabled && !buttondisable && !updateActive
                  ? handleUpdateAccount
                  : () => {},
            }}
          />
          {/* <div
            className={`h-mobile-create-header ${
              !isUpdateDisabled
                ? "bg-positive-act cursor-pointer"
                : "bg-text-disabled cursor-not-allowed"
            } fixed bottom-bottom-base w-width-full text-text-primary items-center justify-center flex font-semibold z-z-index-modal`}
            onClick={!isUpdateDisabled ? handleUpdateAccount : undefined}
          >
            Update
          </div> */}
        </div>
        <div className="px-padding-md lg:px-padding-base mt-margin-base Qsmd:mt-margin-xl pt-padding-base Qsmd:pt-padding-xl">
          <div className="w-width-full Qlg:w-width-md ">
            <div className="flex flex-col Qsmd:pt-padding-md">
              <div className="mt-margin-lg Qmd:mt-margin-base rounded-border-radius-md">
                <CategoriesEdit
                  sortedCategories={sortedCategories}
                  selectedCategories={sliceCategories
                    .filter((x) => selectedCategories.includes(x.id))
                    .map((x) => x.id)}
                  setSelectedCategories={setSelectedCategories}
                  selectAllChecked={selectAllChecked}
                  toggleSelectAll={toggleSelectAll}
                  handleCategorySelect={handleCategorySelect}
                  Title={"Categories"}
                  SubTitle="Not selecting categories will assign all, including future ones, to this account. This is not recommended for security reasons."
                  TitleFontcolor="text-primary"
                  TextSize="font-md"
                  SubTitleFontcolor="text-secondary"
                  SubTitleTextSize="font-xs"
                  TitleFontWeight="semibold"
                  SubTitleFontWeight="normal"
                  isCategoryLoading={isCategoryLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReimbursementCategories;
